import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledButtonList = styled.div`
  display: flex;
  gap: 10px;

  @media only screen and (max-width: ${breakpoints.lg}px) {
    &.hide-mobile {
      display: none;
    }
  }
`;
